<template>
<div class="flow-view-body">
  <v-form-designer :banned-widgets="testBanned" :designer-config="designerConfig" ref="formDesigner">
  </v-form-designer>
  <el-button type="primary"  @click="saveFormJson"><i class="el-icon-finished" />保存</el-button>
  <select-personnel ref="selectPersonnel" />
</div>
</template>

<script>
import Http from "./common/Http";

export default {
  name: "FlowFormDesign",
  data(){
    return {
      loading: false,
      testBanned: [
        'sub-form',
        'alert',
      ],
      designerConfig: {
        languageMenu: true,
      },
      tableData:[]
    }

  },
  methods:{

    saveFormJson() {
      let formJson = this.$refs.formDesigner.getFormJson()
      var that=this;
      if (typeof formJson.formConfig === 'undefined' || formJson.formConfig.length <= 0) {
        this.$message.error('表单不存在！')
      }
      if (typeof formJson.widgetList === 'undefined' || formJson.widgetList.length <= 0) {
        this.$message.error('表单没有控件！')
      }
      let data = {
        'form_name' : Date.now(),
        'vform_json' : formJson,
        'model_table' : formJson.formConfig.modelName
      }
      Http.post("flow/FlowForm/saveForm",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        that.formLoading = false
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.flow-view-body{
  width: calc( 100vw - 160px );
  height: calc( 100vh - 100px );
  display: flex;
  flex-direction: row;
  .v-form{
    width: calc( 100vw - 160px - 400px );
    height: calc( 100vh - 100px );
    background-color: #e3e3e3;
  }
  .flow-handle{
    width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowFormDesign.vue